/* Airward theme — progressive enhancement, no build step required. */
(function () {
  "use strict";

  /* ---------------------------------------------------------------------
     Mobile nav drawer
     --------------------------------------------------------------------- */
  document.querySelectorAll("[data-drawer-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var drawer = document.getElementById(btn.getAttribute("data-drawer-open"));
      if (drawer) {
        drawer.setAttribute("data-open", "true");
        document.body.style.overflow = "hidden";
        var closeBtn = drawer.querySelector("[data-drawer-close]");
        if (closeBtn) closeBtn.focus();
      }
    });
  });
  document.querySelectorAll("[data-drawer-close]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var drawer = btn.closest("[data-drawer]");
      if (drawer) {
        drawer.setAttribute("data-open", "false");
        document.body.style.overflow = "";
      }
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll('[data-drawer][data-open="true"]').forEach(function (drawer) {
        drawer.setAttribute("data-open", "false");
        document.body.style.overflow = "";
      });
    }
  });

  /* ---------------------------------------------------------------------
     Quantity steppers (product + cart)
     --------------------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var stepBtn = e.target.closest("[data-qty-step]");
    if (!stepBtn) return;
    var wrapper = stepBtn.closest(".qty-stepper");
    var input = wrapper && wrapper.querySelector("input[type='number'], input[type='text']");
    if (!input) return;
    var step = parseInt(stepBtn.getAttribute("data-qty-step"), 10);
    var current = parseInt(input.value, 10) || 1;
    var next = Math.max(1, current + step);
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------------------------------------------------------------------
     Cart drawer: fetch + render on add / change / remove
     --------------------------------------------------------------------- */
  var cartType = document.body.getAttribute("data-cart-type") || "notification";
  var drawer = document.getElementById("cart-drawer");

  function renderMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    return (format || "${{amount}}").replace("{{amount}}", amount).replace("{{ amount }}", amount);
  }

  function refreshCartDrawer() {
    if (!drawer) return;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCartDrawer(cart); })
      .catch(function () {});
  }

  function paintCartDrawer(cart) {
    var countEls = document.querySelectorAll("[data-cart-count]");
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "flex" : "none";
    });

    var linesEl = drawer && drawer.querySelector("[data-cart-lines]");
    var emptyEl = drawer && drawer.querySelector("[data-cart-empty]");
    var footEl = drawer && drawer.querySelector("[data-cart-footer]");
    var subtotalEl = drawer && drawer.querySelector("[data-cart-subtotal]");
    if (!linesEl) return;

    if (cart.item_count === 0) {
      linesEl.innerHTML = "";
      if (emptyEl) emptyEl.style.display = "block";
      if (footEl) footEl.style.display = "none";
      return;
    }
    if (emptyEl) emptyEl.style.display = "none";
    if (footEl) footEl.style.display = "block";
    if (subtotalEl) subtotalEl.textContent = renderMoney(cart.total_price);

    linesEl.innerHTML = cart.items.map(function (item, index) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
      return (
        '<div class="cart-line" data-line-item="' + (index + 1) + '">' +
          '<div class="cart-line-media">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : "") + "</div>" +
          '<div>' +
            '<div class="cart-line-title">' + escapeHtml(item.product_title) + "</div>" +
            (item.variant_title ? '<div class="cart-line-variant">' + escapeHtml(item.variant_title) + "</div>" : "") +
            '<div class="qty-stepper" style="margin-top:8px;">' +
              '<button type="button" data-qty-step="-1" data-cart-qty aria-label="Decrease quantity">–</button>' +
              '<input type="number" min="1" value="' + item.quantity + '" data-cart-qty-input data-line="' + (index + 1) + '" aria-label="Quantity">' +
              '<button type="button" data-qty-step="1" data-cart-qty aria-label="Increase quantity">+</button>' +
            "</div>" +
            '<button type="button" class="cart-line-remove" data-cart-remove data-line="' + (index + 1) + '">Remove</button>' +
          "</div>" +
          '<div style="font-weight:600; font-size:14px;">' + renderMoney(item.final_line_price) + "</div>" +
        "</div>"
      );
    }).join("");
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  function changeLine(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCartDrawer(cart); })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) {
      changeLine(removeBtn.getAttribute("data-line"), 0);
    }
  });
  document.addEventListener("change", function (e) {
    var qtyInput = e.target.closest("[data-cart-qty-input]");
    if (qtyInput) {
      changeLine(qtyInput.getAttribute("data-line"), qtyInput.value);
    }
  });

  /* Add-to-cart forms: intercept when drawer mode is active */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[data-add-to-cart-form]");
    if (!form) return;
    if (cartType !== "notification" || !drawer) return; // fall back to normal page submit -> /cart

    e.preventDefault();
    var submitBtn = form.querySelector("[type='submit']");
    var originalText = submitBtn ? submitBtn.textContent : "";
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Adding…"; }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Object.fromEntries(new FormData(form)))
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartDrawer();
        drawer.setAttribute("data-open", "true");
        document.body.style.overflow = "hidden";
      })
      .catch(function () {})
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
      });
  });

  refreshCartDrawer();

  /* ---------------------------------------------------------------------
     Product page: variant → price / image / availability sync
     --------------------------------------------------------------------- */
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var dataEl = document.getElementById(form.getAttribute("data-product-json"));
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var optionInputs = form.querySelectorAll("[data-option-index]");
    var priceEl = document.querySelector("[data-product-price='" + product.id + "']");
    var comparePriceEl = document.querySelector("[data-product-compare-price='" + product.id + "']");
    var saveBadge = document.querySelector("[data-product-save='" + product.id + "']");
    var addBtn = form.querySelector("[data-add-to-cart-btn]");
    var variantIdInput = form.querySelector("[name='id']");
    var mainImage = document.querySelector("[data-gallery-main='" + product.id + "']");

    function currentSelection() {
      var selected = [];
      optionInputs.forEach(function (input) {
        if (input.type === "radio") {
          if (input.checked) selected[parseInt(input.getAttribute("data-option-index"), 10)] = input.value;
        } else {
          selected[parseInt(input.getAttribute("data-option-index"), 10)] = input.value;
        }
      });
      return selected;
    }

    function findVariant() {
      var selected = currentSelection();
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function update() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; }
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = renderMoney(variant.price, window.themeMoneyFormat);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = renderMoney(variant.compare_at_price, window.themeMoneyFormat);
          comparePriceEl.style.display = "";
          if (saveBadge) {
            var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            saveBadge.textContent = "Save " + pct + "%";
            saveBadge.style.display = "";
          }
        } else {
          comparePriceEl.style.display = "none";
          if (saveBadge) saveBadge.style.display = "none";
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute("data-label-add") : addBtn.getAttribute("data-label-sold-out");
      }
      if (mainImage && variant.featured_image) {
        mainImage.src = variant.featured_image.src;
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener("change", update);
    });
    update();
  });

  /* ---------------------------------------------------------------------
     Product gallery thumbnails
     --------------------------------------------------------------------- */
  document.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var group = thumb.closest("[data-gallery]");
      var main = group && group.querySelector("[data-gallery-main]");
      if (main) main.src = thumb.getAttribute("data-full-src");
      group.querySelectorAll("[data-gallery-thumb]").forEach(function (t) { t.setAttribute("aria-current", "false"); });
      thumb.setAttribute("aria-current", "true");
    });
  });

  /* ---------------------------------------------------------------------
     Newsletter form (Shopify customer form posts normally; this just
     shows inline confirmation if the URL contains the success flag)
     --------------------------------------------------------------------- */
  if (window.location.search.indexOf("customer_posted=true") > -1) {
    document.querySelectorAll("[data-newsletter-success]").forEach(function (el) {
      el.style.display = "block";
    });
  }
})();
